import img1 from "./images/book-1.jpg";
import img2 from "./images/book-2.jpg";
import img3 from "./images/book-3.jpg";

export const books = [
  {
    img: img1,
    title: "Interesting Facts For Curious Minds",
    author: "Jordan Moore",
    id: 1,
  },
  {
    img: img2,
    title: "Atomic Habits: Build Good Habits",
    author: "James Clear",
    id: 2,
  },
  {
    img: img3,
    title: "Dad Jokes",
    author: "Jimmy Niro",
    id: 3,
  },
];
